module.exports = __webpack_public_path__ + "static/media/Conexao-ensinoFund-curto.625e4e36.png";